import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import CategoryApi from '@/api/category'

export default (TemplateLibrary) => Vue.component('TemplateLibraryContainer', {
  data() {
    return {
      categories: [],
      featuredTemplatesByCategories: [],
    }
  },
  created() {
    this.getAllCategories()
    this.getFeaturedTemplatesByCategories()
  },
  methods: {
    async getAllCategories() {
      try {
        const res = await CategoryApi.getAllCategoriesV2({
          sortBy: 'order',
          sortDesc: false,
        })
        this.categories = res && res.data
      } catch (e) {
        Sentry.captureException(e)
      }
    },
    async getFeaturedTemplatesByCategories() {
      try {
        const res = await CategoryApi.getFeaturedTemplates({
          isFeatured: true,
        })
        this.featuredTemplatesByCategories = res
          .map((category) => category.featuredTemplate)
          .filter((featuredTemplate) => featuredTemplate)
      } catch (e) {
        Sentry.captureException(e)
      }
    },
  },
  render(createElement) {
    return createElement(TemplateLibrary, {
      props: {
        categories: this.categories,
        featuredTemplatesByCategories: this.featuredTemplatesByCategories,
      },
    })
  },
})
